/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = StandartBooking
 *
 * 2 = WhileYouWait
 *
 * 3 = CollectionAndelivery
 *
 * 4 = LoanCar
 *
 * 5 = Recovery
 */
export enum NewTransportOptionEnum {
  StandartBooking = 1,
  WhileYouWait = 2,
  CollectionAndelivery = 3,
  LoanCar = 4,
  Recovery = 5,
}
